export enum PlanOapPaymentType {
	EFT = 'EFT',
	CreditCard = 'Credit Card',
}
